export default "__VITE_ASSET__ff31a535__"